// src/hooks/useTusUploads.js
import { useCallback, useMemo, useRef, useState } from "react";
import * as tus from "tus-js-client";
const BASE_URL = process.env.REACT_APP_ATLAS_API_RUTE;

function getLastFragment(url) {
    if (!url) return null;

    const parts = url.split("/");
    return parts[parts.length - 1];
}

function pad2(n) {
    return String(n).padStart(2, "0");
}

function formatDateDDMMYY(d = new Date()) {
    const dd = pad2(d.getDate());
    const mm = pad2(d.getMonth() + 1);
    const yy = String(d.getFullYear()).slice(-2);
    const hh = pad2(d.getHours());
    const min = pad2(d.getMinutes());

    return `${dd}-${mm}-${yy}_${hh}-${min}`;
}

export const uploadFileTus = ({
    file,
    token,
    email,
    bacterium,
    analyze,
    onProgress,
}) => {
    return new Promise((resolve, reject) => {
        let attempts = 0;
        const MAX_ATTEMPTS = 40;

        const upload = new tus.Upload(file, {
            endpoint: BASE_URL + "tus",
            retryDelays: [0, 1000, 3000, 5000],

            metadata: {
                filename: file.name,
                filetype: "application/octet-stream",
                token: token,
            },

            onShouldRetry: () => {
                attempts++;

                if (attempts >= MAX_ATTEMPTS) {
                    reject(
                        new Error(
                            "Upload failed: maximum connection attempts reached (40)."
                        )
                    );
                    return false;
                }

                return true;
            },

            onError: (error) => {
                console.error("Upload failed:", error);
                reject(error);
            },

            onProgress: (bytesUploaded, bytesTotal) => {
                const percentage = Number(
                    ((bytesUploaded / bytesTotal) * 100).toFixed(2)
                );

                onProgress?.({
                    fileName: file.name,
                    percentage,
                    bytesUploaded,
                    bytesTotal,
                });
            },

            onSuccess: () => {
                onProgress?.({
                    fileName: file.name,
                    percentage: 100,
                    bytesUploaded: file.size ?? 0,
                    bytesTotal: file.size ?? 0,
                });

                resolve({
                    name_raw: file.name,
                    tus_id: getLastFragment(upload.url),
                });
            },
        });

        upload.start();
    });
};

export const uploadMultipleFilesTus = async ({
    files,
    token,
    email,
    bacterium,
    analyze,
    onProgress,
}) => {
    const results = [];

    try {
        for (const file of files) {
            const url = await uploadFileTus({
                file,
                token,
                email,
                bacterium,
                analyze,
                onProgress,
            });

            results.push(url);
        }

        return results;
    } catch (err) {
        console.error("Upload failed:", err);
        throw new Error("connection_error");
    }
};
